import { Util } from './utils';

export default class Messages {
  // Return a message formatter instance that prefers userMessages
  // but falls back to the default configuration
  static factory(userMessages) {
    userMessages = userMessages || {};
    return function format(key, ...args) {
      let template = userMessages[key] || MESSAGES[key];
      if (typeof template == 'undefined') {
        return null;
      } else {
        return Util.stringFormat(template, ...args);
      }
    };
  }
}

export const WAIT_PREFIX = 'Please Wait.';

const MESSAGES = {
  ///
  /// Misc. UI Element Labels
  ///

  related_title: 'Related Videos',

  four_k_banner_heading: 'This Broadcast is available in Ultra HD!',
  four_k_banner_subtext_before: 'Click the ',
  four_k_banner_subtext_after: ' on the player controls to adjust the broadcast quality.',
  four_k_banner_dismiss: 'Got it',

  purchase_ticket_button: 'Purchase Ticket ({0})',
  purchase_channel_ticket_button: 'Purchase Channel Ticket ({0})',

  purchase_ticket_success_subtitle:
    'You are watching this broadcast with ticket #{0}. Your email contains the link to watch again in the future. Enjoy!',
  purchase_channel_ticket_success_subtitle:
    'You are watching this channel with ticket #{0}. Your email contains the link to watch again in the future. Enjoy!',

  watching_preview_title: 'You Are Watching A Free Preview',
  watching_free_variant_title: 'You Are Watching A Free Low Quality Broadcast',

  broadcast_ended_title: 'Thank You For Watching!',
  broadcast_ended_watch_again_description: 'Click to watch again',

  start_stop_description_current: 'Broadcast started {0} (ending {1})',
  start_stop_description_future: 'Scheduled to broadcast {0} - {1}',
  start_stop_description_past: 'Broadcasted {0} - {1}',

  ticket_zip_code_match: 'Card will be validated to match billing zip code {0}',

  donation_button_label: 'Donate',
  donation_complete: 'Thank you for your generous donation.',

  cue_title: 'Video Markers',
  documents_title: 'Documents',

  stripe_not_loaded:
    'A JavaScript library required for checkout could not be loaded. Please refresh this page and try again.  If the problem persists, you may have an antivirus program or browser extension interfering and might want to switch to Google Chrome.',

  payment_modal_donate_button_text: 'Process Donation ({0})',
  payment_modal_ticket_button_text: 'Pay Now ({0})',
  payment_modal_donate_disclaimer_text: '* Credit card processing fees for the donation are {0}%.',
  payment_modal_ticket_disclaimer_text:
    'This ticket grants you the right to one simultaneous view. Note that abuse of the ticket is tracked and monitored.',
  payment_modal_donate_email_text: 'You will be emailed a receipt after the payment is processed.',
  payment_modal_ticket_email_text:
    'You will be emailed a link to come back and watch later or from a different device.',
  payment_modal_donate_complete: 'Thank you for your generous donation.',
  payment_modal_ticket_complete:
    'Thank you for your ticket purchase.  You can now continue watching the broadcast.',

  payment_modal_donate_item_name: 'Online Donation',

  ///
  /// Player Error States
  ///

  player_upcoming_title: '{4}',
  player_upcoming_subtitle: 'Broadcast starts {0} at {1}.',

  player_preparing_title: '{4}',
  player_preparing_subtitle: 'Broadcast starts {0} at {1}.',

  player_prepared_title: '{4}',
  player_preparing_subtitle: 'Broadcast starts {0} at {1}.',

  player_live_title: '{4}',
  player_live_subtitle: `${WAIT_PREFIX} The Broadcast Will Start Momentarily`, //might happen while origin is 409ing

  player_catching_up_title: '{4}',
  player_catching_up_subtitle: `${WAIT_PREFIX} The Stream Has Not Started`,

  player_offline_title: '{4}',
  player_offline_subtitle: `${WAIT_PREFIX} The Broadcaster Has Not Started Streaming`,

  player_busy_title: '{4}',
  player_busy_subtitle: `${WAIT_PREFIX} The Broadcaster Has Not Started Streaming`,

  player_no_video_input_title: '{4}',
  player_no_video_input_subtitle: `${WAIT_PREFIX} The Broadcaster Has Not Started Streaming`,

  player_updating_firmware_title: '{4}',
  player_updating_firmware_subtitle: `${WAIT_PREFIX} The Broadcaster Has Not Started Streaming`,

  player_processing_recording_title: `${WAIT_PREFIX} The Recording Will Be Available Shortly`,
  player_processing_recording_subtitle: ' ',

  player_processing_highlight_title: `${WAIT_PREFIX} The Highlight Will Be Available Shortly`,
  player_processing_highlight_subtitle: ' ',

  player_recorded_title: ' ',

  player_audio_only: 'This Broadcast is Audio Only',

  player_not_recorded_title: 'No Recording Was Found For This Broadcast',
  player_not_recorded_subtitle: ' ',
  player_missed_title: 'This Broadcast Did Not Air',
  player_live_only_title: 'This Broadcast Was Only Available Live',
  player_live_only_subtitle: 'The recording is not available.',
  player_expired_title: 'This Broadcast Has Expired And Is No Longer Available',
  player_purged_title: 'This Broadcast Is No Longer Available',

  player_no_stream_title: 'The Stream Has Been Disrupted',
  player_no_stream_subtitle: 'It will resume automatically when the disruption is resolved.',

  player_client_disconnected_title: 'Error Loading Broadcast',

  player_genericreason_title: 'The Broadcast Is Unavailable',
  player_genericreason_subtitle: 'Reason: {3}',

  //player_payment_required: 'A ticket is required to view this broadcast.<br><a href="#" class="boxcast-new-ticket">Click here to purchase a ticket</a>',
  //player_forbidden: 'A subscription is required to view this broadcast.<br><a href="#" class="boxcast-new-subscription">Click here to purchase a subscription</a>',
  player_unavailable_due_to_inactive_account_title: 'This Broadcast is Unavailable',
  player_unavailable_title: 'This Broadcast is Unavailable Due to Media Rights Restrictions',
  player_ticket_title: 'This Broadcast Requires a Ticket',
  player_unauthorized_title: 'You Are Not Authorized to Watch This Broadcast',

  player_ticket_via_redirect_title: 'This Broadcast Requires a Ticket',
  player_donate_via_redirect_title: 'You Have Been Redirected Here to Complete Your Donation',

  payment_ticket_title: 'Purchase a Ticket to Watch This Broadcast',
  payment_subscription_title: 'Purchase a Subscription to Watch This Broadcast',
  payment_flex_title: 'Purchase an Upgrade to High Quality',

  payment_ticker_subtitle: 'Click to purchase a ticket and continue watching',
  payment_ticker_flex_subtitle: 'Click to purchase an upgrade to high quality',

  player_not_found_title: 'The Broadcast Is Unavailable',
  player_not_found_subtitle: ' ',

  player_gone_title: 'The Broadcast Is No Longer Available',
  player_gone_subtitle: ' ',

  //MEDIA_ERR_ABORTED
  player_error_code_1_subtitle: 'The request for video was stopped by your device.',
  //MEDIA_ERR_NETWORK
  player_error_code_2_subtitle:
    'A network error occurred. Your internet connection may have been lost.',
  //MEDIA_ERR_DECODE
  player_error_code_3_subtitle: 'The video failed to be decoded by your device.',
  //MEDIA_ERR_SRC_NOT_SUPPORTED
  player_error_code_4_subtitle: 'This video type is not supported by your device.',

  player_error_code_buffering_too_long_title: 'Sorry for the Interruption',
  player_error_code_buffering_too_long_subtitle:
    'The video has been buffering too long. Try reloading the page.',
  player_error_code_buffering_too_long_stalled_subtitle:
    'The stream has stalled. Please wait for the broadcaster to reconnect.',

  player_error_unknown_title: 'There Was an Unexpected Player Error',
  player_error_unknown_subtitle:
    "We're not quite sure what went wrong, but you can try reloading the page. ({0} code {1})",

  geoblock_loading_title: `${WAIT_PREFIX} Checking Your Location`,
  geoblock_loading_subtitle:
    'This is a region-restricted broadcast, so we must confirm your location.',

  geoblock_restricted_title: 'This Broadcast Is Not Available In Your Area',
  geoblock_restricted_subtitle:
    'This is a region-restricted broadcast and cannot be played in your detected location.',

  password_required_title: 'A Password is Required to Unlock This Broadcast',
  password_invalid_title: 'Invalid Password. Please Try Again (passwords are case-sensitive).',
};
